import { createContext } from "react";
import { DefaultSettings, ISettings } from "./Models.ts";

export const SettingsContext = createContext({ settings: DefaultSettings, setSettings: (settings: ISettings) => {}});